module.exports = __webpack_public_path__ + "static/media/Volume.61b42980.svg";